// src/components/templates/TemplateModal.jsx
import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Stack, Autocomplete
} from "@mui/material";

export default function TemplateModal({
                                          open,
                                          initialValue = { name: "", version: "1.0", tag: null },
                                          tagOptions = [],
                                          onClose,
                                          onSave,
                                      }) {
    const [form, setForm] = React.useState(initialValue);

    React.useEffect(() => {
        setForm(initialValue);
    }, [initialValue]);

    const handleSave = () => {
        if (!form.name?.trim()) return alert("Informe um nome.");
        onSave?.(form);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{initialValue?.id ? "Editar template" : "Novo template"}</DialogTitle>

            <DialogContent dividers>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <TextField
                        label="Nome"
                        value={form.name || ""}
                        onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                        autoFocus
                    />

                    <TextField
                        label="Versão"
                        value={form.version || "1.0"}
                        onChange={(e) => setForm((f) => ({ ...f, version: e.target.value }))}
                        sx={{ maxWidth: 180 }}
                    />

                    {/* ✅ tag único (enum) */}
                    <Autocomplete
                        options={tagOptions}
                        value={form.tag || null}
                        onChange={(_, newValue) => setForm((f) => ({ ...f, tag: newValue || null }))}
                        renderInput={(params) => (
                            <TextField {...params} label="Tag" placeholder="Selecione" />
                        )}
                        clearOnEscape
                    />
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleSave}>Salvar</Button>
            </DialogActions>
        </Dialog>
    );
}
